import { React } from "react";
import Header  from "./Header";

function AboutApp () {
    return(
        <>  
            <div style={{ textAlign: 'center' }}>
                <Header text="About App"/>
            </div>
            <div className="container">
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Blanditiis, quasi. Neque similique fugit aspernatur eos debitis qui illum, enim ducimus provident incidunt ipsam possimus saepe? Ratione blanditiis quos incidunt numquam perspiciatis consequuntur architecto ut vel adipisci esse sit eum, est labore maiores doloribus repellat pariatur? Porro, laborum quis totam iure maxime odio dolore animi iste. Nihil voluptate labore ullam corporis eveniet eos consectetur necessitatibus aliquam, consequatur possimus maxime soluta ut vero, neque illo voluptatibus pariatur laboriosam tenetur nobis atque? Sequi omnis voluptates sint pariatur facere minima. Assumenda dolorum obcaecati nostrum vel iusto alias enim, dolorem qui consequatur amet, a doloribus?
            </div>
        </>
    );
}

export default AboutApp;